/* eslint-disable */
export default {
  all: 'すべて',
  company: '会社',
  personal: '個人',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
